import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

type ToastSeverity = 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | string;

@Injectable({ providedIn: 'root' })
export class ToastService {

    constructor(private messageService: MessageService) {}

    showToast(type: ToastSeverity, title: string, body: any, duration: number = 3000) {
        // Map nebular-style types to PrimeNG severity
        let severity: string = type;
        if (type === 'primary') severity = 'info';
        if (type === 'basic')   severity = 'secondary';
        if (type === 'danger')  severity = 'error';
        if (type === 'warning') severity = 'warn';

        this.messageService.add({
            severity,
            summary: title,
            detail: typeof body === 'string' ? body : JSON.stringify(body),
            life: duration,
            closable: true
        });
    }
}
